import { CATEGORIES, MODES } from "../constants";

export const initialState = {
  groups: [],
  currentCategory: CATEGORIES.ALL_STUDENTS.id,
  studentsToShow: [],
  groupsDetails: {},
  currentGroup: null,
  isGroupFetchErr: false,
  isDialogLoading: false,
  areGroupsLoading: false,
  isCreateGroupErr: false,
  searchQuery: "",
  isShowDialog: false,
  isShowDeleteGroupDialog: false,
  mode: MODES.NONE,
  isStudentRemovalDialogOpen: null,
  currentStudentSelected: null,
  isSearchAll: null,
  indirectStudentsPageNumber: 0,
  currentIndirectStudents: [],
  currentIndirectHasMore: false,
  isLoadingIndirectUsers: null,
};
